// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1xZjh","cell":"ColumnAccessor_cell__1w6bI","firstCellAccent":"ColumnAccessor_firstCellAccent__P1bNa"};